<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" :loading="loading" @on-ok="ok">
      <h3 slot="header" class="modal-header">请选择项目状态</h3>
      <div style="text-align: center;" v-if="pageData">
        <RadioGroup v-model="status">
          <Radio class="item" v-for="(item,index) in radioList" :label="item.value"  :key="'keyA'+index">{{item.text}}</Radio>
        </RadioGroup>
      </div>
    </Modal>

  </div>
</template>

<script>
  import {updateConfigStutas} from "../../../../api/projectConfig";
  import {deepClone} from "../../../../utils/format";

  export default {
    name: "StatusModal",
    props:{
      n:{
        type:Number,
        default:0
      },
      pageData:{
        type:Object,
        default:null
      }
    },
    watch:{
      n() {
        this.status=''
        this.isShow = true
      },
    },
    data(){
      return {
        isShow:false,
        loading:true,
        status:''
      }
    },
    computed:{
      radioList(){
        return this.pageData.status===0? [{text:'未开业',value:1},{text:'已到期',value:2}]:[{text:'即将开业',value:3},{text:'已开业',value:0}]
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      // setDefault(){
      //   this.status=this.radioList[0].value
      // },
      ok(){
        if(!(this.status+'')){
          this.changeLoading()
          this.$Message.info('请选择项目状态')
          return
        }
        // let params=deepClone(this.pageData)
        // params['currentStatus']=params['status']
        // params['status']=params['status']==1?0:1
        // params['proStatus']=this.status
        let params={
          proStatus:this.status,
          projectFid:this.pageData.projectFid,
          currentStatus:this.pageData.status
        }

        updateConfigStutas(params).then(res=>{
          this.isShow=false
          this.$Message.success('操作成功')
          this.$emit('operatedone')
        })
      }
    }

  }
</script>

<style scoped>
  .item{
    margin-right: 20px;
  }

</style>
